import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import PropTypes from "prop-types";


import Header from "./Header";

const MainWrapper = styled(Box)(
	({ theme }) => `
        flex: 1 1 auto;
        display: flex;
        height: 100%;`
);

const MainContent = styled(Box)(
	({ theme }) => `
        height: calc(100% - ${theme.header.height} - ${theme.spacing(1)});
        top: ${theme.header.height};
        margin-top: ${theme.spacing(1)};
        left: ${theme.spacing(1)};
        width: calc(100% - ${theme.spacing(1)});
        position: relative;
        overflow-y: auto;
        overflow-x: hidden;
`
);

const BoxedSidebarLayout = ({ children }) => (
	<>
		<MainWrapper>
			<Header />
			<MainContent>
				{children}
			</MainContent>
		</MainWrapper>
	</>
);

BoxedSidebarLayout.propTypes = {
	children: PropTypes.node
};

export default BoxedSidebarLayout;
